import { Capacitor } from '@capacitor/core';

export const PROD_API_URL = 'https://ideconecta.idebrasilm.com.br/api';
export const PROD_BASE_URL = 'https://ideconecta.idebrasilm.com.br';

// Helper to read runtime-injected config (env-config.js) with fallbacks
export function getRuntimeConfig() {
  const win = typeof window !== 'undefined' ? window : (globalThis as any);
  const runtime = (win as any).__RUNTIME_CONFIG__ || {};

  // If running inside native mobile app (Capacitor on Android or iOS)
  const isNative = Capacitor.isNativePlatform() || 
    (typeof window !== 'undefined' && (
      window.location.protocol === 'capacitor:' || 
      (window.location.origin.includes('localhost') && navigator.userAgent.includes('wv'))
    ));

  if (isNative) {
    const customUrl = runtime.REACT_APP_API_URL;
    if (customUrl && !customUrl.includes('localhost') && !customUrl.includes('127.0.0.1')) {
      return { REACT_APP_API_URL: customUrl };
    }
    return { REACT_APP_API_URL: PROD_API_URL };
  }

  return {
    REACT_APP_API_URL: runtime.REACT_APP_API_URL || process.env.REACT_APP_API_URL || PROD_API_URL,
  } as { REACT_APP_API_URL: string };
}

export function getApiUrl(): string {
  return getRuntimeConfig().REACT_APP_API_URL;
}

export function formatMediaUrl(url?: string | null): string {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  const cleanPath = url.startsWith('/') ? url : `/${url}`;
  return `${PROD_BASE_URL}${cleanPath}`;
}
